import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { PRELOADED_ASSETS_NUM } from 'site-modules/pictures/constants/pictures';
import { SOURCES, getImageUrl } from 'client/utils/image-helpers';
import { getPictureSrc } from 'site-modules/pictures/utils/gallery-utils';
import { PhotoflipperButtonAsync } from 'site-modules/shared/components/photoflipper-core/photoflipper-button/photoflipper-button-async';
import { GalleryPicturePlaceholder } from 'site-modules/pictures/components/gallery-picture-placeholder/gallery-picture-placeholder';

export function GalleryPicture({ title = null, src = null, params, num, isMobile = false }) {
  if (!src) {
    return null;
  }

  const { make, model, year, submodel, pageNum, category } = params;
  const photoflipperProps = {
    makeSlug: make,
    modelSlug: model,
    year,
    submodel,
    galleryPfOptions: {
      pageNum,
      selectedCategory: category,
      gallerySubmodel: submodel,
      currentSlide: num,
      isGalleryPf: true,
    },
    skipAdUnitsBetweenSlides: true,
  };

  return (
    <GalleryPicturePlaceholder>
      <PhotoflipperButtonAsync {...photoflipperProps}>
        <Button color="link" className="d-block p-0" aria-label="Open photoflipper">
          <img
            alt={title}
            title={title}
            src={getPictureSrc(getImageUrl(src, undefined, SOURCES.MEDIA), isMobile)}
            className="gallery-picture w-100 rounded"
            loading={num <= PRELOADED_ASSETS_NUM ? undefined : 'lazy'}
          />
        </Button>
      </PhotoflipperButtonAsync>
    </GalleryPicturePlaceholder>
  );
}

GalleryPicture.propTypes = {
  params: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    submodel: PropTypes.string,
    category: PropTypes.string,
    pageNum: PropTypes.number,
  }).isRequired,
  num: PropTypes.number.isRequired,
  title: PropTypes.string,
  src: PropTypes.string,
  isMobile: PropTypes.bool,
};
